<template>

<div class="page-content">

    <SeoMeta 
        title="TheJobTap.com - AI and Blockchain job skills" 
        description="Discover opportunities tailored to your expertise in AI, Blockchain, Web3 and beyond."
    />

                <section class="pt-28 lg:pt-44 pb-28 group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 dark:bg-neutral-900 bg-[url('../images/home/page-title.png')] bg-center bg-cover relative" >
                    <div class="container mx-auto">
                        <div class="grid">
                            <div class="col-span-12">
                                <div class="text-center text-white">
                                    <h1 class="mb-4 text-[26px]">Explore AI and Web3 jobs over {{ Number(this.jobListingCategoriesTotal).toLocaleString() }} skills</h1>
                                    <div class="page-next">
                                     <!-- <p>Discover opportunities tailored to your expertise in AI, Blockchain, Web3 and beyond.</p> -->
                                     <p>Discover jobs based on the skills you already have or want to build. TheJobTap.com helps you find opportunities across AI, Web3, blockchain, and modern tech by focusing on the technologies, tools, and expertise employers are actively hiring for.</p>
                                     <!-- <p>Whether you're working with <strong>Python, React, Solidity, Kubernetes, machine learning, or cloud platforms</strong>, you can explore roles that match your skill set and career direction.</p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img rel="prefetch" src="@/assets/images/about/shape.png" alt="header image" class="absolute block bg-cover -bottom-0 dark:hidden" style="width: 100%;">
                    <img rel="prefetch" src="@/assets/images/about/shape-dark.png" alt="header image dark" class="absolute hidden bg-cover -bottom-0 dark:block" style="width: 100%;">
                </section>

                    <section class="py-16">
                        <div v-if="isLoading" class="container mx-auto">
                            <Loader></Loader>
                        </div>
                        <div v-else class="container mx-auto">
                            <div class="grid grid-cols-12 gap-y-12 lg:gap-10">
                                <div class="col-span-12 lg:col-span-10 lg:col-start-2">
                                   <!-- <div class="mb-5 text-center"> -->
                                   <div class="">
                                        <!-- <p class="inline px-2 py-1 text-sm font-medium text-white bg-yellow-500 rounded">Jobs Live Today</p> -->
                                        <!-- <p class="mt-2 text-gray-500 dark:text-gray-300">Find your perfect job by searching for specific skills. Browse job listings that match your skill set and take the next step in your career today!</p> -->
                                    
                                        <section class="mb-8">
                                        <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-50 mb-4">
                                            Why search jobs by skills?
                                        </h2>

                                        <ul class="space-y-3 text-gray-500 dark:text-gray-300 pl-5">
                                            <li><strong>Find more relevant roles</strong> aligned to your actual expertise</li>
                                            <li><strong>Discover niche opportunities</strong> that don’t appear in generic job searches</li>
                                            <li><strong>Track in-demand technologies</strong> across AI, Web3, and emerging tech</li>
                                            <li><strong>Plan your next move</strong> by exploring which skills are growing fastest</li>
                                        </ul>
                                        </section>

                                        <section class="mb-8">
                                        <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-50 mb-4">
                                            Popular tech skills in demand
                                        </h2>

                                        <p class="text-gray-500 dark:text-gray-300 mb-4">
                                            The demand for specialised technical skills continues to grow across AI and Web3. Some of the most sought-after skills include:
                                        </p>

                                        <ul class="space-y-3 text-gray-500 dark:text-gray-300 mb-4 pl-5">
                                            <li><strong>Programming languages:</strong> Python, JavaScript, TypeScript, Rust, Go</li>
                                            <li><strong>Frontend technologies:</strong> React, Vue, modern UI frameworks</li>
                                            <li><strong>Backend & infrastructure:</strong> Node.js, .NET, Kubernetes, Docker, cloud platforms</li>
                                            <li><strong>AI & data:</strong> Machine learning, LLMs, data engineering, PyTorch</li>
                                            <li><strong>Web3 & blockchain:</strong> Solidity, smart contracts, DeFi, decentralised applications</li>
                                        </ul>

                                        <p class="text-gray-500 dark:text-gray-300 mb-2 mt-5">
                                            <strong>Popular searches:</strong>
                                        </p>
                                        <ul class="space-y-3 text-gray-500 dark:text-gray-300 mb-4 pl-5">
                                            <li><router-link to="/job-skills/python/" class="text-blue-500 mb-2"><i class="mdi mdi-chevron-right"></i> Python jobs</router-link></li>
                                            <li><router-link to="/job-skills/react/" class="text-blue-500"><i class="mdi mdi-chevron-right"></i> React jobs</router-link></li>
                                            <li><router-link to="/job-skills/solidity/" class="text-blue-500"><i class="mdi mdi-chevron-right"></i> Solidity jobs</router-link></li>
                                            <li><router-link to="/job-skills/kubernetes/" class="text-blue-500"><i class="mdi mdi-chevron-right"></i> Kubernetes jobs</router-link></li>
                                            <li><router-link to="/job-skills/smart contracts/" class="text-blue-500"><i class="mdi mdi-chevron-right"></i> Smart contract jobs</router-link></li>
                                        </ul>
                                            
                                        </section>

                                        <section class="mb-8">
                                        <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-50 mb-4">
                                            Build your career around your skills
                                        </h2>

                                        <p class="text-gray-500 dark:text-gray-300 mb-4">
                                            Searching by job title can limit your options. Searching by skills opens up a wider range of opportunities across industries, roles, and companies.
                                        </p>

                                        <p class="text-gray-500 dark:text-gray-300 mb-4">
                                            Whether you're a developer, engineer, analyst, or product specialist, focusing on your core skills helps you find roles that better match your experience and long-term goals.
                                        </p>
                                        </section>

                                        <section>
                                        <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-50 mb-4">
                                            Start exploring
                                        </h2>

                                        <p class="text-gray-500 dark:text-gray-300 mb-4">
                                            Browse job opportunities by skill and discover where your expertise is most valuable. From AI and machine learning to Web3 and cloud infrastructure, your next role could be just one skill away.
                                        </p>
                                        </section>
                                        
                                        <section>
                                            <p class="text-gray-500 dark:text-gray-300 text-center mt-10">
                                                <strong>Select a skill to explore available jobs and take the next step in your career.</strong>
                                            </p>
                                        </section>
                                    </div>
                                </div>
                            </div>
                            <div class="grid grid-cols-12 gap-y-5 md:gap-8">
                                <div class="col-span-12 md:col-span-6 xl:col-span-4">
                                    <div class="mt-10 rounded bg-gray-50 dark:bg-neutral-700">
                                        <div class="p-6">
                                            <ul class="space-y-4">
                                                <li class="px-4 py-2 bg-white rounded dark:bg-neutral-600" 
                                                    v-bind:key="jobListingCategory.Name" 
                                                    v-for="jobListingCategory in jobListingCategories.slice(0, jobListingCategoriesTotal / 3)">
                                                    <router-link :to="/job-skills/ + encodeURIComponent(jobListingCategory.Name) + '/'" class="text-gray-900 dark:text-white">{{ jobListingCategory.Name }}
                                                        <span class="px-2 py-1 rounded active text-11 text-gray-500 dark:text-gray-300 ltr:float-right rtl:float-left">{{ Number(jobListingCategory.JobListingCount).toLocaleString()  }}</span>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-span-12 md:col-span-6 xl:col-span-4">
                                    <div class="mt-10 rounded bg-gray-50 dark:bg-neutral-700">
                                        <div class="p-6">
                                            <ul class="space-y-4">
                                                <li 
                                                    class="px-4 py-2 bg-white rounded dark:bg-neutral-600" 
                                                    v-bind:key="jobListingCategory.Name" 
                                                    v-for="jobListingCategory in jobListingCategories.slice(jobListingCategoriesTotal / 3, (jobListingCategoriesTotal / 3) * 2)">
                                                    <router-link :to="/job-skills/ + jobListingCategory.Name + '/'" class="text-gray-900 dark:text-white">{{ jobListingCategory.Name }}
                                                        <span class="px-2 py-1 rounded active text-11 text-gray-500 dark:text-gray-300 ltr:float-right rtl:float-left">{{ jobListingCategory.JobListingCount }}</span>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-span-12 md:col-span-6 xl:col-span-4">
                                    <div class="mt-10 rounded bg-gray-50 dark:bg-neutral-700">
                                        <div class="p-6">
                                            <ul class="space-y-4">
                                                <li class="px-4 py-2 bg-white rounded dark:bg-neutral-600"
                                                    v-bind:key="jobListingCategory.Name" 
                                                    v-for="jobListingCategory in jobListingCategories.slice(jobListingCategoriesTotal / 3 * 2, (jobListingCategoriesTotal / 3) * 3)">
                                                    <router-link :to="/job-skills/ + jobListingCategory.Name + '/'" class="text-gray-900 dark:text-white">{{ jobListingCategory.Name }}
                                                        <span class="px-2 py-1 rounded active text-11 text-gray-500 dark:text-gray-300 ltr:float-right rtl:float-left">{{ jobListingCategory.JobListingCount }}</span>
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

            </div>
</template>

<script>

import { jobListingCategoryAPI } from "@/api/jobListingCategory";
import { useStatus } from "@/api/composables/status";
import { useErrorLogger } from "@/api/composables/errorLogging";
import Loader from "@/components/Loader.vue";
import SeoMeta from "@/components/Seo/SeoMeta.vue";

const pageStatus = useStatus();
const log = useErrorLogger();

export default{
  name: "JobListingSearchCategories",
  components : { 
    Loader, SeoMeta
  }, 
  setup () 
  {
  },
  data() {
    return {
      isLoading: true,
      tagSearch: [],
      jobListingCategories: [],
      jobListingCategoriesTotal: null
    };
  },
  mounted() {
      document.title = 'Job Skills - TheJobTap.com'
      this.getJobListingCategories();
  },
  methods: {
  async getJobListingCategories() {
    this.isLoading = true;
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await jobListingCategoryAPI.getCategories();
          result.forEach((element) => { 
            this.jobListingCategories.push(element);
          })
          this.jobListingCategoriesTotal = result.length;
        })
      );
      this.isLoading = false;
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };        
      }
    },
  }
}
</script>